export const contactUsInitialValues = {
  topic: "",
  message: "",
};
